import { render, staticRenderFns } from "./top-section3.vue?vue&type=template&id=3cf197ef&scoped=true&"
import script from "./top-section3.vue?vue&type=script&lang=ts&"
export * from "./top-section3.vue?vue&type=script&lang=ts&"
import style0 from "./top-section3.vue?vue&type=style&index=0&id=3cf197ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf197ef",
  null
  
)

export default component.exports